import { Text, Button } from "@mantine/core";
import { IconX, IconCheck } from "@tabler/icons-react";
import { ActionIcon } from "@mantine/core";

interface SelectItemPopupProps {
  visible: boolean;
  selectedCount: number;
  onConfirm: () => void;
  onDismiss: () => void;
}

export const SelectItemPopup = ({
  visible,
  selectedCount,
  onConfirm,
  onDismiss,
}: SelectItemPopupProps) => {
  if (!visible) return null;

  return (
    <div className="flex-shrink-0 bg-amber-50 border-b border-amber-200 px-4 py-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <div>
            <Text fw={600} size="sm">
              Select Items
            </Text>
            <Text size="xs" c="dimmed">
              Click products to select/deselect
            </Text>
          </div>
          {selectedCount > 0 && (
            <Text size="xs" fw={500} c="blue">
              {selectedCount} product{selectedCount !== 1 ? "s" : ""} selected
            </Text>
          )}
        </div>
        <div className="flex items-center gap-1">
          <Button
            size="xs"
            leftSection={<IconCheck size={14} />}
            onClick={onConfirm}
            disabled={selectedCount === 0}
          >
            Done
          </Button>
          <ActionIcon size="sm" variant="subtle" onClick={onDismiss}>
            <IconX size={14} />
          </ActionIcon>
        </div>
      </div>
    </div>
  );
};
